import { render, staticRenderFns } from "./CalendarComponent.vue?vue&type=template&id=67104fdf"
import script from "./CalendarComponent.vue?vue&type=script&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67104fdf')) {
      api.createRecord('67104fdf', component.options)
    } else {
      api.reload('67104fdf', component.options)
    }
    module.hot.accept("./CalendarComponent.vue?vue&type=template&id=67104fdf", function () {
      api.rerender('67104fdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CalendarComponent.vue"
export default component.exports